import { configureStore } from '@reduxjs/toolkit';
import envData from './envSlice';
import userData from './userSlice';
import errorData from './errorSlice';
import catalogData from './catalogSlice';
import messagingData from './messagingSlice';
import tutorialData from './tutorialSlice';
import curatedData from './curatedSlice';
import collectionData from './collectionSlice';
import indexData from './indexSlice';
import enrollmentData from './enrollmentSlice';
import coachingRequestData from './coachingRequestSlice';

const reducer = {
  catalogData,
  userData,
  envData,
  errorData,
  tutorialData,
  curatedData,
  collectionData,
  messagingData,
  indexData,
  enrollmentData,
  coachingRequestData,
};

export default configureStore({
  reducer,
});

export const generateStore = (preloadedState) => configureStore({
  reducer,
  preloadedState,
});
